export default __webpack_public_path__ + "static/media/covid5.12560e26.jpg";